import { render } from "./Lottery_add.vue?vue&type=template&id=7ba2778c"
import script from "./Lottery_add.vue?vue&type=script&lang=js"
export * from "./Lottery_add.vue?vue&type=script&lang=js"
script.render = render

export default script